// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconProps } from "@insite/mobius/Icon";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface InfoDisplayStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    contentText?: TypographyProps;
    statusIcon?:IconProps;
}

export const infoDisplayStyles: InfoDisplayStyles = {
    wrapper: {
        css: css`
            margin-bottom: 5px;
            width: 100%;
            display: flex;
        `,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            margin-bottom: 0;
            padding-right: 2px;
            white-space: nowrap;
            font-weight: 600;
        `,
    },
    contentText: {
        css: css`
            text-align: left;
            line-height: 20px;
            white-space: normal;
            font-size: 16px;
        `,
    },
    statusIcon: {
        css: css`
            padding-top: 7px;
        `
    }
};

export const infoDisplayStylesTwo: InfoDisplayStyles = {
    wrapper: {
        css: css``,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            margin-bottom: 5px;
        `,
    },
    contentText: {
        css: css``,
    },
};
